"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var ExternalOptionTypes = _interopRequireWildcard(require("customer-data-objects/property/ExternalOptionTypes"));

var OptionTypes = _interopRequireWildcard(require("customer-data-objects/property/OptionTypes"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _COMPANY$CONTACT$DEAL;

var _default = (_COMPANY$CONTACT$DEAL = {}, (0, _defineProperty2.default)(_COMPANY$CONTACT$DEAL, _ObjectTypes.COMPANY, {
  '_inbounddbio.importid_': ExternalOptionTypes.INBOUND_DB_IMPORT,
  hs_analytics_first_touch_converting_campaign: ExternalOptionTypes.CAMPAIGN,
  hs_analytics_last_touch_converting_campaign: ExternalOptionTypes.CAMPAIGN,
  hs_persona: ExternalOptionTypes.PERSONA,
  hubspot_owner_id: ExternalOptionTypes.OWNER,
  hubspot_team_id: ExternalOptionTypes.TEAM
}), (0, _defineProperty2.default)(_COMPANY$CONTACT$DEAL, _ObjectTypes.CONTACT, {
  associatedcompanyid: ExternalOptionTypes.COMPANY,
  '_inbounddbio.importid_': ExternalOptionTypes.INBOUND_DB_IMPORT,
  'formSubmissions.formId': ExternalOptionTypes.FORM,
  'listMemberships.listId': ExternalOptionTypes.LIST,
  hs_analytics_first_touch_converting_campaign: ExternalOptionTypes.CAMPAIGN,
  hs_analytics_last_touch_converting_campaign: ExternalOptionTypes.CAMPAIGN,
  hs_persona: ExternalOptionTypes.PERSONA,
  hubspot_owner_id: ExternalOptionTypes.OWNER,
  hubspot_team_id: ExternalOptionTypes.TEAM,
  salesforcecampaignids: ExternalOptionTypes.SALESFORCE_CAMPAIGN
}), (0, _defineProperty2.default)(_COMPANY$CONTACT$DEAL, _ObjectTypes.DEAL, {
  '_inbounddbio.importid_': ExternalOptionTypes.INBOUND_DB_IMPORT,
  'engagement.ownerId': ExternalOptionTypes.OWNER,
  deal_currency_code: ExternalOptionTypes.MULTI_CURRENCY_CURRENCY_CODE,
  dealstage: ExternalOptionTypes.DEAL_STAGE,
  hs_persona: ExternalOptionTypes.PERSONA,
  hubspot_owner_id: ExternalOptionTypes.OWNER,
  hubspot_team_id: ExternalOptionTypes.TEAM,
  pipeline: ExternalOptionTypes.DEAL_PIPELINE
}), (0, _defineProperty2.default)(_COMPANY$CONTACT$DEAL, _ObjectTypes.ENGAGEMENT, {
  hs_activity_type: ExternalOptionTypes.ACTIVITY_TYPE,
  hs_at_mentioned_owner_ids: ExternalOptionTypes.OWNER,
  hs_created_by: ExternalOptionTypes.USER,
  hs_call_disposition: ExternalOptionTypes.CALL_DISPOSITION,
  hubspot_team_id: ExternalOptionTypes.TEAM
}), (0, _defineProperty2.default)(_COMPANY$CONTACT$DEAL, _ObjectTypes.LINE_ITEM, {
  hs_line_item_currency_code: ExternalOptionTypes.MULTI_CURRENCY_CURRENCY_CODE
}), (0, _defineProperty2.default)(_COMPANY$CONTACT$DEAL, _ObjectTypes.QUOTE, {
  hubspot_team_id: ExternalOptionTypes.TEAM
}), (0, _defineProperty2.default)(_COMPANY$CONTACT$DEAL, _ObjectTypes.TICKET, {
  '_inbounddbio.importid_': ExternalOptionTypes.INBOUND_DB_IMPORT,
  hs_pipeline_stage: ExternalOptionTypes.TICKET_STAGE,
  hs_pipeline: ExternalOptionTypes.TICKET_PIPELINE,
  hubspot_owner_id: ExternalOptionTypes.OWNER,
  hubspot_team_id: ExternalOptionTypes.TEAM
}), (0, _defineProperty2.default)(_COMPANY$CONTACT$DEAL, _ObjectTypes.VISIT, {
  maxemployees: OptionTypes.MAX_EMPLOYEES,
  maxrevenue: OptionTypes.MAX_REVENUE,
  minemployees: OptionTypes.MIN_EMPLOYEES,
  minrevenue: OptionTypes.MIN_REVENUE
}), _COMPANY$CONTACT$DEAL);

exports.default = _default;
module.exports = exports.default;